const iconLightbulb = `
  <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
    <g fill="none">
      <path d="M0 0h30v30H0z"/>
      <g fill-rule="nonzero" transform="translate(3 2)">
        <path class="icon-color" fill="#0F8BB8" d="M9.455 20.159c.007-.632-.089-1.492-.64-2.225-.216-.285-.413-.443-.642-.639 0 0-.996-.866-1.916-2.225-1.383-2.048-.673-4.95-.64-5.082.183-.702.767-2.51 2.55-3.812.571-.417 1.802-1.176 3.51-1.27 1.554-.09 2.709.417 3.191.638a7.142 7.142 0 0 1 2.234 1.587c.286.303.838.941 1.276 1.909.228.505.748 1.681.64 3.18 0 0-.209 2.774-2.55 4.766-.064.057-.337.278-.641.638a4.463 4.463 0 0 0-.641.955 3.505 3.505 0 0 0-.318 1.586H9.45l.006-.006zM13.77 24.445c0 .86-.723 1.555-1.611 1.555-.889 0-1.612-.695-1.612-1.555"/>
        <rect class="icon-color" fill="#0F8BB8" x="9.366" y="20.652" width="5.806" height="1.504" rx=".711"/>
        <rect class="icon-color" fill="#0F8BB8" x="9.278" y="22.605" width="5.984" height="1.523" rx=".717"/>
        <path stroke="#0F8BB8" stroke-width="1.269" fill="#FFF" stroke-linecap="round" d="M12.146 2.573V0M21.411 11.41 24 11.404M0 11.41l2.583-.012M3.63 2.939 5.457 4.76M19.133 18.534l1.827 1.821M20.814 2.939 18.987 4.76M5.311 18.067l-1.827 1.82"/>
      </g>
    </g>
  </svg>
`

export default iconLightbulb
